import "./ButtonFocus.css";
import { useChatboxDispatchContext, useChatboxStateContext } from "../../../context/ChatboxContext";
import focus from '../../../assets/focus.svg';

const ButtonFocus = () => {

    const { valueToggleFocus } = useChatboxStateContext();

    const dispatch = useChatboxDispatchContext();

    const toggleFocus = () => dispatch({ type: "toggleFocus" })

    return (
        <button id="kwalys-focus" onClick={toggleFocus} className={valueToggleFocus ? 'active' : ''}>
            <img src={focus} alt="focus" width="18px"/>
        </button>
    );
};

export default ButtonFocus;